<script setup>
import {toRefs} from "vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
});
const {modelValue} = toRefs(props)
const emit = defineEmits(['update:modelValue'])
</script>

<template lang="pug">
  .checkbox
    label
      input(type="checkbox" :checked="modelValue" @change="emit('update:modelValue', $event.target.checked)")
      .custom-checkbox
      slot
</template>

<style scoped lang="sass">
@use '@assets/styles/mixin' as *

.custom-checkbox
  +size(100%)
  background-image: url(@public/checkbox/default.svg)
  background-size: cover
  cursor: pointer

label > input[type="checkbox"]
  +size(0)
  position: absolute
  opacity: 0

  &:checked + .custom-checkbox, &.checked + .custom-checkbox
    background-image: url(@public/checkbox/checked.svg)

  &:not(:checked):hover + .custom-checkbox
    background-image: url(@public/checkbox/hover.svg)

</style>
